import React from 'react'
import { isAllowPriceVariant } from '../../lib/AllStaticVariables'
import FeaturesAndAttributes from './FeaturesAndAttributes'
import ManageSizeValues from './ManageSizeValues'
import ManageSizeWarehouseQuantities from './ManageSizeWarehouseQuantities'
import PackagingDetails from './PackagingDetails'
import PriceVariant from './PriceVariant'
import PricingCalculation from './PricingCalculation'
import PricingDetails from './PricingDetails'

const WarehouseAndPrice = ({
  allState,
  values,
  setFieldValue,
  calculation,
  setCalculation,
  resetForm,
  errors,
  touched
}) => {
  return (
    <>
      {(allState?.color?.length > 0 ||
        allState?.sizeType?.length > 0 ||
        values?.productPrices?.filter(
          (productPrice) => productPrice?.isCheckedForQty
        )?.length > 0) && (
        <div className='card'>
          <div className='card-body'>
            <div>
              <h5 className='mb-3 head_h3'>Attributes</h5>
              <div className='row'>
                <FeaturesAndAttributes
                  values={values}
                  setFieldValue={setFieldValue}
                  allState={allState}
                  resetForm={resetForm}
                  errors={errors}
                  touched={touched}
                />

                {values?.productPrices?.length > 0 &&
                  !values?.isSizeWisePriceVariant &&
                  allState?.sizeType?.length > 0 && (
                    <ManageSizeValues
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors.productPrices}
                      resetForm={resetForm}
                      allState={allState}
                    />
                  )}

                {values?.productPrices?.length > 0 &&
                  !values?.isSizeWisePriceVariant &&
                  values?.productPrices
                    ?.filter((productPrice) => productPrice?.isCheckedForQty)
                    ?.map((productPrice, index) => (
                      <ManageSizeWarehouseQuantities
                        productPrice={productPrice}
                        values={values}
                        setFieldValue={setFieldValue}
                        allState={allState}
                        errorObj={
                          Array.isArray(errors.productPrices)
                            ? errors.productPrices[index]
                            : null
                        }
                        touchedObj={
                          Array.isArray(touched.productPrices)
                            ? touched.productPrices[index]
                            : null
                        }
                      />
                    ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className='row'>
        <div className='col-md-6'>
          <div className='card'>
            <div className='card-body'>
              <div className='row mb-3'>
                {!values?.isSizeWisePriceVariant && (
                  <PackagingDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    allState={allState}
                    calculation={calculation}
                    setCalculation={setCalculation}
                    errors={errors}
                    touched={touched}
                  />
                )}
                <PricingDetails
                  values={values}
                  allState={allState}
                  setFieldValue={setFieldValue}
                  setCalculation={setCalculation}
                  calculation={calculation}
                  errors={errors.productPrices}
                  touched={touched}
                  resetForm={resetForm}
                />

                {values?.isSizeWisePriceVariant && (
                  <PackagingDetails
                    values={values}
                    setFieldValue={setFieldValue}
                    allState={allState}
                    calculation={calculation}
                    setCalculation={setCalculation}
                    errors={errors}
                    touched={touched}
                  />
                )}
              </div>
              {isAllowPriceVariant && (
                <PriceVariant
                  values={values}
                  setFieldValue={setFieldValue}
                  setCalculation={setCalculation}
                  calculation={calculation}
                  allState={allState}
                  productPricesErrors={errors.productPrices}
                  resetForm={resetForm}
                />
              )}
            </div>
          </div>
        </div>
        {calculation?.displayCalculation && (
          <PricingCalculation
            calculation={calculation}
            setCalculation={setCalculation}
          />
        )}
      </div>
    </>
  )
}

export default WarehouseAndPrice
